export default __webpack_public_path__ + "static/media/light-OFF.4e2b562a.svg";